import { css } from '@/styled-system/css';

export const galleryContainer = css({
  position: 'relative',
  width: '100%',
  aspectRatio: '4/3',
  backgroundColor: 'hpxGrey100',
  touchAction: 'pan-y',
  cursor: 'grab',
  userSelect: 'none',
  md: {
    aspectRatio: 'auto',
  },
});

export const galleryTrack = css({
  display: 'flex',
  height: '100%',
  willChange: 'transform',
  transitionProperty: 'transform',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
});

export const galleryTrackDragging = css({
  transitionDuration: '0s',
});

export const gallerySlide = css({
  flexShrink: 0,
  width: '100%',
  height: '100%',
});

export const galleryImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  pointerEvents: 'none',
  userSelect: 'none',
});

export const mobileCarouselWrapper = css({
  display: 'block',
  height: '100%',
  overflow: 'hidden',
  md: {
    display: 'none',
  },
});

export const desktopBentoGridBase = css({
  display: 'none',
  md: {
    display: 'grid',
    gap: '1x',
    height: '510px',
    borderRadius: '12px',
    overflow: 'hidden',
    position: 'relative',
  },
});

export const desktopBentoGrid1 = css({
  md: {
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
  },
});

export const desktopBentoGrid2 = css({
  md: {
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
  },
});

export const desktopBentoGrid3 = css({
  md: {
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr 1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6', gridRow: 'span 2' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
    '& > *:nth-child(3)': { gridColumn: 'span 4' },
  },
});

export const desktopBentoGrid4 = css({
  md: {
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr 1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
    '& > *:nth-child(3)': { gridColumn: 'span 4' },
    '& > *:nth-child(4)': { gridColumn: 'span 6' },
  },
});

export const bentoImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  transitionProperty: 'transform',
  transitionDuration: '0.2s',
});

export const bentoButton = css({
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  overflow: 'hidden',
  width: '100%',
  height: '100%',
  _hover: {
    '& img': {
      transform: 'scale(1.03)',
    },
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
  },
});

export const desktopOverlayButtons = css({
  position: 'absolute',
  bottom: '2x',
  right: '2x',
  display: 'flex',
  gap: '1x',
  zIndex: 'zIndexStep',
});

export const overlayButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: 'rgba(0, 0, 0, 0.60)',
  color: 'hpxWhite',
  border: 'none',
  borderRadius: '4px',
  paddingX: '4px',
  paddingY: '6px',
  fontSize: 'sm',
  lineHeight: '1',
  whiteSpace: 'nowrap',
  fontWeight: '500',
  cursor: 'pointer',
  _hover: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const imageCounter = css({
  position: 'absolute',
  bottom: '2x',
  left: '2x',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: 'rgba(0, 0, 0, 0.60)',
  color: 'hpxWhite',
  border: 'none',
  borderRadius: '4px',
  paddingX: '4px',
  paddingY: '6px',
  fontSize: 'sm',
  lineHeight: '1',
  whiteSpace: 'nowrap',
  fontWeight: '500',
  cursor: 'pointer',
  zIndex: 'zIndexStep',
  _hover: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  md: {
    display: 'none',
  },
});

export const mobileOverlayButtons = css({
  position: 'absolute',
  bottom: '2x',
  right: '2x',
  display: 'flex',
  gap: '6px',
  zIndex: 'zIndexStep',
  md: {
    display: 'none',
  },
});

export const verifiedBadge = css({
  position: 'absolute',
  bottom: '2x',
  right: '2x',
  zIndex: 'zIndexStep',
  md: {
    bottom: 'unset',
    right: 'unset',
    top: '2x',
    left: '2x',
  },
});

export const verifiedBadgeAboveBadges = css({
  bottom: '52px',
  md: {
    bottom: 'unset',
  },
});

export const verifiedBadgeInner = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: 'rgba(0, 0, 0, 0.60)',
  color: 'hpxWhite',
  borderRadius: '4px',
  paddingX: '4px',
  paddingY: '6px',
  fontSize: 'sm',
  lineHeight: '1',
  whiteSpace: 'nowrap',
  fontWeight: '500',
  cursor: 'pointer',
  md: {
    _hover: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  },
});

export const verifiedIcon = css({
  width: '18px',
  height: '14px',
});

export const verifiedLabel = css({
  display: 'inline',
});

export const mobileOverlayButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: 'rgba(0, 0, 0, 0.60)',
  color: 'hpxWhite',
  border: 'none',
  borderRadius: '4px',
  paddingX: '4px',
  paddingY: '6px',
  fontSize: 'sm',
  lineHeight: '1',
  whiteSpace: 'nowrap',
  fontWeight: '500',
  cursor: 'pointer',
  _hover: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});
